import '@total-typescript/ts-reset';
import { isChromiumIosInjectedError } from '@mozioinc/utils';
import { init, BrowserTracing } from '@sentry/react';
import posthog from 'posthog-js';

const setSentry = (options) => {
  const {
    env,
    dsn,
    version,
    // TODO: ask backend to add "sentry-trace" and "baggage" to CORS allowlist https://docs.sentry.io/platforms/javascript/usage/distributed-tracing/
    // tracePropagationTargets = [/^https:\/\/api\.mozio\.com/],
    tracePropagationTargets = [],
    organization,
    projectId,
    ignoreErrors
  } = options;
  if (env !== "production" && env !== "preview") {
    return;
  }
  if (!dsn) {
    console.error("Sentry DSN is not set");
    return;
  }
  init({
    dsn,
    environment: env,
    release: version,
    integrations: [
      // Performance Monitoring
      new BrowserTracing({
        // backend apis to trace https://docs.sentry.io/platforms/javascript/performance/instrumentation/automatic-instrumentation/#tracepropagationtargets
        tracePropagationTargets
      }),
      ...projectId ? [new posthog.SentryIntegration(posthog, organization, projectId)] : []
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1,
    ignoreErrors,
    beforeSend: (event) => {
      const isInjected = isChromiumIosInjectedError(event, {
        userAgent: navigator.userAgent,
        origin: location.origin
      });
      return isInjected ? null : event;
    }
  });
};

export { setSentry };
